import { createContext, useContext } from "react";

export const IsFirstModuleContext = createContext<boolean>(false);

export const useIsFirstModule = () => useContext(IsFirstModuleContext);
